import { Component, OnInit, Input, HostListener } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpClient } from "@angular/common/http";
import { OpAdminProductListService } from "src/app/views/common/services/op-admin-product-list.service";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../../../../../environments/environment";

@Component({
  selector: "app-image-dialog",
  templateUrl: "./image-dialog.component.html",
  styleUrls: ["./image-dialog.component.css"],
})
export class ImageDialogComponent implements OnInit {
  myCanvas: any;
  image_360: any = [];
  productDetial: any = [];
  threeSixtyImages: any = null;
  currentImage: any;
  currentImageIndex: any = 0;
  scrHeight: any;
  scrWidth: any;
  isTouchDevice: any = false;
  firstImage: any;
  lastImage: any;
  arrayLength = 0;

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() productId: string;
  @Input() storeType: string;

  is360 = true;
  isZoomImage = false;
  isVideoUrl = false;
  srcURL = null;
  constructor(
    private activeModal: NgbActiveModal,
    public _sanitize: DomSanitizer,
    private http: HttpClient,
    private activeRoute: ActivatedRoute,
    private productListService: OpAdminProductListService,
    public _DomSanitizationService: DomSanitizer
  ) {}
  ngOnInit() {
    let url =
      environment.URL +
      "/productImages/" +
      this.productId +
      "/" +
      this.storeType +
      "/" +
      this.is360 +
      "/" +
      this.isZoomImage +
      "/" +
      this.isVideoUrl;
    this.srcURL =
      this._DomSanitizationService.bypassSecurityTrustResourceUrl(url);

    this.productListService
      .getImagesByProduct(
        this.productId,
        this.storeType,
        this.is360,
        this.isZoomImage,
        this.isVideoUrl
      )
      .subscribe((res: any) => {
        let vFrame = document.getElementById(
          "image_360_animation"
        ) as HTMLIFrameElement;
        vFrame.srcdoc = res.data;
      });
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;

    if (this.scrWidth >= 320 && this.scrWidth <= 768) {
      this.isTouchDevice = true;
    } else {
      this.isTouchDevice = false;
    }
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize() {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    if (this.scrWidth >= 320 && this.scrWidth <= 768) {
      this.isTouchDevice = true;
    } else {
      this.isTouchDevice = false;
    }
  }
  direction = "";
  oldx = 0;
  drag(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.isTouchDevice == false) {
      if (event.pageX < this.oldx) {
        this.direction = "left";
        if (this.currentImageIndex == 0) {
          this.currentImageIndex = this.image_360.length - 1;
        }

        this.currentImageIndex = this.currentImageIndex - 1;
        this.currentImage = this.image_360[this.currentImageIndex];
      }
      if (event.pageX > this.oldx) {
        this.direction = "right";
        if (this.currentImageIndex == this.image_360.length) {
          this.currentImageIndex = 0;
        }
        this.currentImageIndex = this.currentImageIndex + 1;
        this.currentImage = this.image_360[this.currentImageIndex];
      }

      this.oldx = event.pageX;
    }
  }

  touch(event) {
    if (this.isTouchDevice == true) {
      if (this.currentImage == undefined) {
        this.currentImageIndex = 0;
      }

      if (event.touches[0].clientX <= this.oldx) {
        this.direction = "left";
        if (this.currentImageIndex == 0) {
          this.currentImageIndex = this.image_360.length;
        }

        this.currentImageIndex = this.currentImageIndex - 1;
        this.currentImage = this.image_360[this.currentImageIndex];
      }
      if (event.touches[0].clientY >= this.oldx) {
        this.direction = "right";
        if (this.currentImageIndex == this.image_360.length) {
          this.currentImageIndex = 0;
        }
        this.currentImageIndex = this.currentImageIndex + 1;
        this.currentImage = this.image_360[this.currentImageIndex];
      }

      this.oldx = event.touches[0].clientX;
    }
  }
  @HostListener("dragstart", ["$event"])
  onDrag(event: any) {
    var img = document.createElement("img");
    img.src =
      "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=";
    event.dataTransfer.setDragImage(img, 0, 0);
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
  // public threeSixtyImages=
  // {
  //   0:
  //   [
  //     'assets/images/kettle 360/RH-kettle-5_01.jpg',
  //     'assets/images/kettle 360/RH-kettle-5_05.jpg',
  //     'assets/images/kettle 360/RH-kettle-5_09.jpg',
  //     'assets/images/kettle 360/RH-kettle-5_13.jpg',
  //     'assets/images/kettle 360/RH-kettle-5_17.jpg',
  //     'assets/images/kettle 360/RH-kettle-5_21.jpg',
  //     'assets/images/kettle 360/RH-kettle-5_25.jpg',
  //     'assets/images/kettle 360/RH-kettle-5_29.jpg',
  //     'assets/images/kettle 360/RH-kettle-5_33.jpg',
  //   ]
  // }
}
